var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-end my-1",
          attrs: { cols: "12" },
        },
        [
          _vm.HasPermission(_vm.PermissionList.Sales_Create)
            ? _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.show("add-opportunity-modal")
                    },
                  },
                },
                [_vm._v(" Add Opportunity ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
        [
          _c(
            "b-form-group",
            { staticClass: "mb-0" },
            [
              _c(
                "label",
                { staticClass: "d-inline-block text-sm-left mr-50" },
                [_vm._v("Per page")]
              ),
              _c("b-form-select", {
                staticClass: "w-50",
                attrs: {
                  id: "perPageSelect",
                  options: _vm.pageOptions.map(function (option) {
                    return { text: option, value: option }
                  }),
                  size: "sm",
                },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { md: "10" } },
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                label: "Filter",
                "label-cols-sm": "8",
                "label-align-sm": "right",
                "label-size": "sm",
                "label-for": "filterInput",
              },
            },
            [
              _c(
                "b-input-group",
                { attrs: { size: "sm" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "filterInput",
                      type: "search",
                      placeholder: "Type to Search",
                    },
                    on: { input: _vm.onSearch },
                    model: {
                      value: _vm.searchQuery,
                      callback: function ($$v) {
                        _vm.searchQuery = $$v
                      },
                      expression: "searchQuery",
                    },
                  }),
                  _c(
                    "b-input-group-append",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { disabled: !_vm.searchQuery },
                          on: {
                            click: function ($event) {
                              _vm.searchQuery = ""
                            },
                          },
                        },
                        [_vm._v(" Clear ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            {
              staticClass: "mb-3",
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            },
            [
              _c("b-tab", { attrs: { title: "All", active: "" } }),
              _vm._l(_vm.statusOptions, function (option) {
                return _c("b-tab", {
                  key: option.value,
                  attrs: { title: option.text },
                })
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { cols: "12" } },
        [
          _c(
            "b-form-group",
            { staticClass: "mb-0", attrs: { label: "Select Columns:" } },
            [
              _c("b-form-checkbox-group", {
                attrs: { options: _vm.columnOptions },
                model: {
                  value: _vm.selectedColumns,
                  callback: function ($$v) {
                    _vm.selectedColumns = $$v
                  },
                  expression: "selectedColumns",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _vm.showTable
            ? _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  responsive: "",
                  items: _vm.opplist,
                  fields: _vm.dynamicFields,
                  "per-page": _vm.perPage,
                  "current-page": _vm.currentPage,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc,
                },
                on: {
                  "update:sortBy": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function ($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": function ($event) {
                    _vm.sortDesc = $event
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(expectedCloseDate)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatDate(data.item.expectedCloseDate)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(createdOn)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDate(data.item.createdOn)) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(closeDate)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDate(data.item.closeDate)) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(status)",
                      fn: function (data) {
                        return [
                          _c(
                            "b-badge",
                            {
                              attrs: {
                                variant: _vm.getBadgeVariant(data.item.status),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.beautifyStatus(data.item.status))
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(estimateValue)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            " Rs " +
                              _vm._s(
                                _vm.formatAmount(data.item.estimateValue)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(salespersonId)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getSalePersonName(data.item.salespersonId)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(description)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            " " + _vm._s(data.item.description || " - ") + " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(actions)",
                      fn: function (data) {
                        return [
                          _c(
                            "b-dropdown",
                            {
                              attrs: {
                                variant: "link",
                                "toggle-class": "text-decoration-none",
                                "no-caret": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "button-content",
                                    fn: function () {
                                      return [
                                        _c("feather-icon", {
                                          staticClass:
                                            "text-body align-middle mr-25",
                                          attrs: {
                                            icon: "MoreVerticalIcon",
                                            size: "16",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm.HasPermission(_vm.PermissionList.Sales_View)
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        to: _vm.viewOpportunity(data.item.id),
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "EyeIcon" },
                                      }),
                                      _c("span", [_vm._v("View")]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "b-dropdown-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.prepareEditOpportunity(
                                        data.item
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "Edit2Icon" },
                                  }),
                                  _c("span", [_vm._v("Edit")]),
                                ],
                                1
                              ),
                              _vm.HasPermission(_vm.PermissionList.Sales_Delete)
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteOpportunity(
                                            data.item.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "TrashIcon" },
                                      }),
                                      _c("span", [_vm._v("Delete")]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.isEdit
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.promptChangeStatus(
                                            data.item
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "RotateCcwIcon" },
                                      }),
                                      _c("span", [_vm._v("Change Status")]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3340058599
                ),
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.loadingopp
                ? _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "success", label: "Spinning", block: "" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-pagination", {
                staticClass: "my-0",
                attrs: {
                  "total-rows": _vm.rows,
                  "per-page": _vm.perPage,
                  align: "center",
                  size: "sm",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "change-Opportunity-status-modal",
            title: "Change Opportunity Status",
          },
          on: { ok: _vm.changeStatus },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function (ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                return [
                  _c(
                    "b-button",
                    { attrs: { variant: "secondary" }, on: { click: cancel } },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        disabled: _vm.isStatusChangeDisabled,
                        variant: "primary",
                      },
                      on: { click: ok },
                    },
                    [_vm._v("Change Status")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                label: "Select New Status:",
                "label-for": "status-select",
              },
            },
            [
              _c("b-form-select", {
                attrs: { id: "status-select", options: _vm.statusOptions },
                on: { change: _vm.isStatusChangeDisabled },
                model: {
                  value: _vm.selectedStatus,
                  callback: function ($$v) {
                    _vm.selectedStatus = $$v
                  },
                  expression: "selectedStatus",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "add-opportunity-modal", title: "Add Opportunity" },
          on: {
            ok: function ($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            },
            hidden: _vm.resetForm,
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function (ref) {
                var ok = ref.ok
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", disabled: _vm.submitting },
                      on: { click: _vm.onSubmit },
                    },
                    [
                      _vm.submitting
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v(
                        " " + _vm._s(_vm.submitting ? "Adding..." : "Add") + " "
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mx-auto", attrs: { cols: "12" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "mb-3",
                      attrs: { title: "Add Opportunity" },
                    },
                    [
                      _c("validation-observer", {
                        ref: "AddForm",
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var invalid = ref.invalid
                              return [
                                _c(
                                  "b-form",
                                  {
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return _vm.onSubmit($event)
                                      },
                                    },
                                  },
                                  [
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Customer Name:",
                                            "label-for": "customer-lead",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.getLeadName(_vm.id)) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Assign to*",
                                          "label-for": "salesperson",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Salesperson",
                                            vid: "Salesperson",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        options:
                                                          _vm.salesPersonOptions,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .salespersonId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "salespersonId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.salespersonId",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Opportunity Name:",
                                          "label-for": "name",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Opportunity Name",
                                            vid: "Opportunity Name",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "name",
                                                        type: "text",
                                                        required: "",
                                                        placeholder:
                                                          "Enter Opportunity Name",
                                                      },
                                                      model: {
                                                        value: _vm.form.name,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "name",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "form.name",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Status:",
                                          "label-for": "status-select",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Status",
                                            vid: "Status",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        id: "status-select",
                                                        options:
                                                          _vm.statusOptions,
                                                        required: "",
                                                      },
                                                      model: {
                                                        value: _vm.form.status,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "status",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.status",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Amount:",
                                          "label-for": "amount",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "amount",
                                            type: "number",
                                            required: "",
                                            placeholder: "Enter amount",
                                          },
                                          model: {
                                            value: _vm.form.estimateValue,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "estimateValue",
                                                $$v
                                              )
                                            },
                                            expression: "form.estimateValue",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Expected Close Date:",
                                          "label-for": "expected-close-date",
                                        },
                                      },
                                      [
                                        _c("b-form-datepicker", {
                                          attrs: {
                                            id: "expected-close-date",
                                            required: "",
                                            placeholder: "Select a date",
                                          },
                                          model: {
                                            value: _vm.form.expectedCloseDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "expectedCloseDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.expectedCloseDate",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Description:",
                                          "label-for": "Description",
                                        },
                                      },
                                      [
                                        _c("b-form-textarea", {
                                          attrs: {
                                            id: "textarea-default",
                                            placeholder: "Description",
                                            rows: "3",
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.form.description,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression: "form.description",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "edit-opportunity-modal", title: "Edit Opportunity" },
          on: {
            ok: function ($event) {
              $event.preventDefault()
              return _vm.updateOpportunity($event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function (ref) {
                var ok = ref.ok
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", disabled: _vm.submitting },
                      on: { click: _vm.updateOpportunity },
                    },
                    [
                      _vm.submitting
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v(
                        " " +
                          _vm._s(_vm.submitting ? "Editing..." : "Edit") +
                          " "
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mx-auto", attrs: { cols: "12" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "mb-3",
                      attrs: { title: "Edit Opportunity" },
                    },
                    [
                      _c("validation-observer", {
                        ref: "EditForm",
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var invalid = ref.invalid
                              return [
                                _c(
                                  "b-form",
                                  {
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return _vm.updateOpportunity($event)
                                      },
                                    },
                                  },
                                  [
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Customer Name:",
                                            "label-for": "customer-lead",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.getLeadName(_vm.id)) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Assign to*",
                                          "label-for": "salesperson",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Salesperson",
                                            vid: "Salesperson",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        options:
                                                          _vm.salesPersonOptions,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.editFormData
                                                            .salespersonId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.editFormData,
                                                            "salespersonId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "editFormData.salespersonId",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Opportunity Name:",
                                          "label-for": "name",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Opportunity Name",
                                            vid: "Opportunity Name",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        id: "name",
                                                        type: "text",
                                                        required: "",
                                                        placeholder:
                                                          "Enter Opportunity Name",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.editFormData.name,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.editFormData,
                                                            "name",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "editFormData.name",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Status:",
                                          "label-for": "status-select",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Status",
                                            vid: "Status",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        id: "status-select",
                                                        options:
                                                          _vm.statusOptions,
                                                        required: "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.editFormData
                                                            .status,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.editFormData,
                                                            "status",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "editFormData.status",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Amount:",
                                          "label-for": "amount",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "amount",
                                            type: "number",
                                            required: "",
                                            placeholder: "Enter amount",
                                          },
                                          model: {
                                            value:
                                              _vm.editFormData.estimateValue,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.editFormData,
                                                "estimateValue",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "editFormData.estimateValue",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Expected Close Date:",
                                          "label-for": "expected-close-date",
                                        },
                                      },
                                      [
                                        _c("b-form-datepicker", {
                                          attrs: {
                                            id: "expected-close-date",
                                            required: "",
                                            placeholder: "Select a date",
                                          },
                                          model: {
                                            value:
                                              _vm.editFormData
                                                .expectedCloseDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.editFormData,
                                                "expectedCloseDate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "editFormData.expectedCloseDate",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Description:",
                                          "label-for": "Description",
                                        },
                                      },
                                      [
                                        _c("b-form-textarea", {
                                          attrs: {
                                            id: "textarea-default",
                                            placeholder: "Description",
                                            rows: "3",
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.editFormData.description,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.editFormData,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "editFormData.description",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }